import ServiceBus from 'servicestack/service-bus'
import ModalController from 'webmodals/modal.controller'
import Design from 'emun.on-demand/lib/design'
import Media from 'webutils/media/media'
import resolve from 'ioc/resolve'
import utils from 'emun.on-demand/lib/util';

class ExtendDesignPromptController extends ModalController {
    constructor($uibModalInstance, options) {
        super($uibModalInstance)
        const $ctrl = this;

        $ctrl.bus = new ServiceBus()
        $ctrl.title = options.title || `Change Text...`;
        $ctrl.subTitle = options.subTitle || options.design.label;
        $ctrl.src = options.design;
        $ctrl.request = {
            predecessorId: options.design.id,
            objects: []
        };
        
        resolve('$http').get(options.design.designUrl()).then(res => {
            res.data.objects.reverse().forEach(o => {
                console.log(o.type,  o.layerId,o);
                if(o.type === 'text'){
                    $ctrl.request.objects.push({
                        layer: utils.splatName(o.layerId),
                        layerId: o.layerId,
                        text: o.text
                    });
                    console.warn(o.text);
                }
            });
        });
    }
    
    submit() {
        const $ctrl = this;
        $ctrl.bus.send('ExtendDesign.json', $ctrl.request).then(res => {
            var design = $ctrl.trg = new Design(res.data);
            //console.debug('design', design);
            //$ctrl.close(design);
        });
    }
}

export default ExtendDesignPromptController;
